﻿// requires: js.cookie.js
// requires: efw.dialog.js
// requires: efw.sessionTimer.js
/* global require */
(function ($) {
    // globals
    var OFFER_COOKIE_STEM = "efw.offer.";
    var COOKIE_SETTINGS = { sameSite: 'strict', secure: true };
    const Cookies = require('js-cookie');

    // Eightfold Way offer plugin
    $.fn.offer = function (opts) {
        var $opts = $.extend($.fn.offer.defaults, opts);

        var _cookieName = function () {
            return OFFER_COOKIE_STEM + $opts.offerName;
        };

        var _isVeto = function () {
            // is veto cookie present?
            var c = Cookies.get(_cookieName());
            if ('undefined' !== typeof c)
                return true;

            // or: does our current path match any of the specified vetoPaths?
            var here = window.location.href,
                anyMatch = false;
            $.each($opts.vetoPaths, function (i, fragment) {
                //console.log(`Matching ${fragment} to ${here}`);
                if (here.indexOf(fragment) >= 0) {
                    anyMatch = true;
                }
            });

            return anyMatch;
        };

        var _setVeto = function (t) {
            Cookies.set(_cookieName(), { start: $.now() }, { ...COOKIE_SETTINGS, expires: t }); // NOTE: Automatic handling of JSON input is obsolete in js-cookie 3.0.0+. Will have to rethink JSON semantics.
        };

        var _setVetoForever = function () {
            _setVeto(10 * 365);
        };

        var _setVetoTemp = function () {
            _setVeto($opts.declineDays);
        }

        return this.each(function () {
            // configure dialog
            var $dlgControl = $(this);
            var $this = $(this);
            $dlgControl.efw$dialog($opts);

            // any show of the dialog sets a veto - don't show again soon
            $dlgControl.on('show.bs.modal', function () {
                _setVetoTemp();
            });

            // clicking "offer accept" generates a forever veto.
            $opts.findAccept($dlgControl).on('click', function (e) {
                _setVetoForever();
                $opts.onAccept(e.delegateTarget);
            });

            // clicking "ask me later" generates a deferral.
            $opts.findDefer($dlgControl).on('click', function () {
                _setVeto($opts.deferDays);
            });

            $dlgControl.find('.btn').on('click', function () {
                // regardless, any button click closes the dialog.
                $this.modal('hide');
            });

            var _pop = function (d) {
                d.modal('show');
            }

            // page load action
            $(document).ready(function () {
                if (!_isVeto()) {
                    var t = $.sessionTimer.get();
                    if (t.count >= $opts.sessionPageCount)
                        setTimeout(function () { _pop($dlgControl); }, 1000);
                    // setTimeout with data parameter not supported in IE8
                }
            });
        });

    };

    // default option parameters
    $.fn.offer.defaults = { sessionPageCount: 5, declineDays: 30, deferDays: 1, offerName: 'offer', vetoPaths: ['/planning/'], findAccept: function (d) { return $(d).find('.accept'); }, onAccept: function (/*d*/) { return; }, findDefer: function (d) { return $(d).find('.defer'); } };
})(jQuery);